<template>
	<div full-height>
		<v-toolbar flat fixed>
			<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
		    <v-toolbar-title class="white--text">Accountant Access</v-toolbar-title>
		</v-toolbar>

		<div class="hasToolbar">
			<v-alert type="info" :value="true">
				Access your Clients Business data for Free in just three easy steps.
			</v-alert>

			<v-card noshadow>
				<v-card-text>

					<div style="font-size:16px;line-height:28px !important">
                        <p class="ma-0" redcolor>Step 1</p>
		            	<p>Invite your clients to download and register on BizOps App</p>
                        <div><v-btn class="ml-0" color="primary" @click="fn_sendInvite">Send Invitation</v-btn></div>
                        <br>

                        <p class="ma-0" redcolor>Step 2</p>
		            	<p class="mb-1">Ask your clients to add you as an Accountant via <strong>More > Accountant Access</strong></p>
                        <br>

                        <p class="ma-0" redcolor>Step 3</p>
		            	<p class="mb-1">Use Desktop Login to access their business data via <strong>Desktop Login</strong></p>
		            </div>

				</v-card-text>
			</v-card>
		</div>

	</div>
</template>

<script>
export default{
    methods:{
        fn_sendInvite: function(){
            let shareObj = {};
            shareObj.type = "text/plain";
            shareObj.primaryMobileNumber = null;
            shareObj.email = null;
            shareObj.shareType = "share";
            shareObj.subject = "Install BizOps App"
            shareObj.textMessage = this.$tShare('share.invitationMessage', {
                mobile: this.fn_getMobileNumber()
            })
            // shareObj.textMessage = "https://play.google.com/store/apps/details?id=com.bizops.app";
            this.$root.fn_share(shareObj);
        },

        fn_getMobileNumber: function(){
            if(this.$root.CurrentBusiness && this.$root.CurrentBusiness.BusinessProfileNumber){
                return this.$root.CurrentBusiness.BusinessProfileNumber.substring(2, 12);
            }
            else{
                return '';
            }
        },

        fn_goBack: function(){
            this.$router.go(-1);
        },
    },
    mounted: function () {
        window.js_globals.fn_onBackPress = this.fn_goBack;
    }
}
</script>


// WEBPACK FOOTER //
// src/components/settings/send_invitation.vue